module.exports = __webpack_public_path__ + "static/media/sendmessage.8596647d.svg";